@use '@design/design-tokens/typography/typography' as *;

.badge [data-badge='textual'] {
  padding: 2px 4px;
  border-radius: 2px;
}

.mainInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 52px;
  max-width: 60%;

  &.isTooltip {
    min-height: fit-content;
    max-width: 100%;
    gap: 5px;
  }
}

.insightNameWrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.insightName {
  @include typography-v2-title-base;

  &.isTooltip {
    @include typography-v2-title-sm;
  }
}

.infoDetail {
  @include typography-v2-body-sm;
  display: flex;
  gap: 4px;
  padding-right: 8px;
  border-right: 1px solid var(--border-default);

  &.isTooltip {
    @include typography-v2-body-xs;
  }
}

.infoDetailWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.episode {
  white-space: nowrap;
  @include typography-v2-body-xs;
}

.median {
  font-family: var(--font-roboto-mono);

  &.isBullish {
    color: var(--viz-bullish);
  }

  &.isBearish {
    color: var(--viz-bearish);
  }
}

.dot {
  color: var(--icon-soft);
}

.starsLabel {
  display: inline-flex;
  align-items: center;
  gap: 2px;

  svg {
    fill: var(--icon-primary);
  }
}
